import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _21e5a04e = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _30759f92 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _6d876cb0 = () => interopDefault(import('..\\pages\\have-a-card\\index.vue' /* webpackChunkName: "pages_have-a-card_index" */))
const _9d2fb5d4 = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _66b1ec3e = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _70b6864c = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _607947c3 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _5f9c4f12 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _b479408c = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _b45d118a = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _b424b386 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _b4088484 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _4aacca0a = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _2a2e9c67 = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _a971dcba = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _21e5a04e,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _30759f92,
    children: [{
      path: "",
      component: _6d876cb0,
      name: "have-a-card"
    }, {
      path: "enrollment",
      component: _9d2fb5d4,
      name: "have-a-card-enrollment"
    }, {
      path: "success",
      component: _66b1ec3e,
      name: "have-a-card-success"
    }]
  }, {
    path: "/rejection",
    component: _70b6864c,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _607947c3,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _5f9c4f12,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _b479408c,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _b45d118a,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _b424b386,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _b4088484,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _4aacca0a,
    name: "errors-500"
  }, {
    path: "/patient/patientSearch",
    component: _2a2e9c67,
    name: "patient-patientSearch"
  }, {
    path: "/",
    component: _a971dcba,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
